<template>
  <div class="plan flex flex-col">
    <div
      class="fixed z-50 bg-primary h-40 flex items-center justify-end"
      style="width: calc(100% - 19rem);"
    >
      <div class="flex flex-col items-end">
        <div class="pr-6">
          Nikandros Mavroudakis
        </div>
        <div>
          <Button flat>Message Client</Button>
        </div>
      </div>
      <div class="mx-5">
        <Avatar src="prof_pic.jpg" :size="110" />
      </div>
      <div class="fixed top-44" style="width: calc(100% - 19rem);">
        <div class="absolute -top-8 left-0 right-0 flex justify-center">
          <Tabs v-model="selectedTab" :tabs="tabs" />
        </div>
        <div class="flex justify-between">
          <BackButton class="ml-7" @click="goBack" />
          <div v-if="newPlan" class="flex items-center">
            <FadeTransition>
              <SaveButton v-show="unsavedChanges" @save="save" />
            </FadeTransition>
            <Button flat>Publish</Button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="oldPlans" class="mt-52">
      <MealWeek
        v-for="weekly_plan in getPastMealPlans"
        :key="`week_no_${weekly_plan.week_no}`"
        :week="weekly_plan.week_no"
        :start_day="weekly_plan.starting_date"
        :meals="weekly_plan.plan"
        past-meal-plan
      />
    </div>
    <div v-else class="mt-52">
      <MealWeek :week="getPastMealPlans.length + 1" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BackButton from "@/components/BackButton";
import handleBack from "@/mixins/handleBack";
import unsavedChanges from "@/mixins/unsavedChanges";
import MealWeek from "@/pages/MealPlanner/components/MealWeek";

export default {
  name: "MealPlannerIndex",
  components: {
    BackButton,
    MealWeek
  },
  mixins: [handleBack, unsavedChanges],
  computed: {
    objectId() {
      return this.$route?.params?.clientId;
    },
    oldPlans() {
      return this.selectedTab === "past-plans";
    },
    newPlan() {
      return this.selectedTab === "new-plan";
    },
    ...mapGetters(["getWeeklyMealPlan", "getPastMealPlans"])
  },
  data() {
    return {
      selectedTab: "new-plan",
      tabs: [
        {
          name: "Past plans",
          value: "past-plans"
        },
        {
          name: "New plan",
          value: "new-plan"
        }
      ]
    };
  },
  mounted() {
    if (!this.objectId) {
      this.$router.replace({ name: "MyClients" });
    }

    this.$store.dispatch("fetchPastMealPlans");
    this.track("getWeeklyMealPlan", "saveWeeklyPlan");
  }
};
</script>

<style scoped>
.plan::after {
  content: "";
  @apply mr-10;
}

#weeklyMeals::after {
  content: "";
  @apply pr-10;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
